import processLiveGameEventsBasketball from "./processLiveGameEvents.basketball.tsx";

// Mutates boxScore!!!
export const processLiveGameEvents = ({
	events,
	boxScore,
	overtimes,
	quarters,
}: {
	events: any[];
	boxScore: any;
	overtimes: number;
	quarters: any[];
	sportState?: any;
}) => {
	return processLiveGameEventsBasketball({
		events,
		boxScore,
		overtimes,
		quarters,
	});
};
